import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Users } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const IMG =
  "https://images.unsplash.com/photo-1690531611148-8a54db2fdcad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHx3b21lbiUyMGdyb3VwJTIwdHJhdmVsJTIwZnJpZW5kcyUyMGx1eHVyeSUyMGdldGF3YXl8ZW58MHx8fHwxNzkwNjEwMDU1fDA&ixlib=rb-4.1.0&q=60&w=1200";

export default function GroupTeaser() {
  const { t } = useLang();

  return (
    <section data-testid="group-teaser" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMG} alt="" className="w-full h-full object-cover" loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-[#0B2E4A]/85" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 py-24 sm:py-28">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#D9A854] mb-4 flex items-center gap-2">
            <Users size={14} /> {t("group.homeTeaserEyebrow")}
          </p>
          <h2 className="font-display font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#FAF6EE] text-balance">
            {t("group.homeTeaserTitle")}
          </h2>
          <p className="mt-5 text-[#F1E7D6]/75 text-base sm:text-lg leading-relaxed">{t("group.homeTeaserText")}</p>
          <Link
            to="/viajes-en-grupo"
            data-testid="group-teaser-cta"
            className="mt-8 inline-flex items-center gap-2 bg-[#D9A854] hover:bg-[#C99944] text-[#0B2E4A] font-semibold px-8 py-4 rounded-full transition-all duration-200 shadow-xl shadow-[#D9A854]/25 hover:scale-[1.03] active:scale-95"
          >
            {t("group.homeTeaserCta")} <ArrowRight size={17} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
